<template>
	<v-dialog v-model="localValue" persistent max-width="40%" transition="dialog-top-transition">
		<v-form v-model="valid" ref="form">
			<v-card>
				<v-card-title>{{$t('create-account')}}</v-card-title>
				<v-card-text class="py-0 px-3">
					<v-row align="start" class="align-content-center justify-space-between mx-0" wrap>
						<v-col cols="12" lg="6" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-text-field
								:action-name="actions.CREATE"
								context="account"
								:label="$t('account-name')"
								:rules="[rules.required]"
								v-model="account.name"
							></bee-text-field>
						</v-col>

						<v-col cols="12" lg="6" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-account-autocomplete
								context="account"
								:action-name="actions.CREATE"
								:label="$t('main-account')"
								color="primary"
								v-model="account.parent_account_id"
								:items="configs.accounts.filter(c=>c.type == 1)"
								@change="change()"
								:with-balance="true"
								:clearable="true"
							></bee-account-autocomplete>
						</v-col>

						<v-col cols="12" lg="6" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-accounting-no-field
								ref="accountNum"
								:prefix="prefix"
								:rules="[rules.required]"
								v-model="account.inner_accounting_no"
							></bee-accounting-no-field>
						</v-col>

						<v-col cols="12" lg="6" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-autocomplete
								context="account"
								:action-name="actions.CREATE"
								color="primary"
								v-model="account.type"
								@change="onTypeChanged()"
								:label="$t('account-type.label')"
								:items="configs.account_types.filter(c=>c.value).map(c=>({...c, name: c.value == 1 ? $t('account-type.main') : c.value == 2 ? $t('account-type.sub') : c.name })) || []"
								item-text="name"
								:rules="[rules.required]"
								item-value="value"
							></bee-autocomplete>
						</v-col>

						<v-col cols="12" lg="6" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-autocomplete
								context="account"
								:action-name="actions.CREATE"
								:label="$t('final-account')"
								v-model="account.final_type"
								:items="configs.final_account_types.filter(c=>c.value).map(c=>({...c, name: c.value == 1 ? $t('account-type.operations') : c.value == 2 ? $t('account-type.trade') : c.value == 3 ? $t('account-type.gains-and-losses') : c.value == 4 ? $t('account-type.budget') : c.name })) || []"
								itemText="name"
								item-value="value"
							></bee-autocomplete>
						</v-col>

						<v-col cols="12" lg="6" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-multi-select
								:label="$t('account.custom-statement')"
								v-model="account.custom_statement_ids"
								:items="custom_statements"
								item-text="name"
								item-value="id"
								:disabled="account.type == 1"
							></bee-multi-select>
						</v-col>

						<v-col cols="12" lg="4" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-money-field
								context="account"
								:action-name="actions.CREATE"
								:label="$t('account.max-debit-amount')"
								v-model="account.max_debit_amount"
								:rules="[rules.money]"
							></bee-money-field>
						</v-col>

						<v-col cols="12" lg="4" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-money-field
								context="account"
								:action-name="actions.CREATE"
								:label="$t('account.max-credit-amount')"
								v-model="account.max_credit_amount"
								:rules="[rules.money]"
							></bee-money-field>
						</v-col>

						<v-col cols="12" lg="4" md="6" sm="12" xs="12" class="d-flex justify-start px-lg-1 pt-lg-0">
							<bee-checkbox class="mt-lg-1" :label="$t('account.debt-is-forbidden')" v-model="account.is_debt_forbidden"></bee-checkbox>
						</v-col>

						<v-col cols="12" lg="12" md="12" sm="12" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<v-textarea rows="1" color="#334463" :label="$t('account.notes')" v-model="account.notes" outlined></v-textarea>
						</v-col>
					</v-row>

					<v-row align="start" class="align-content-center justify-space-between mx-0" wrap>
						<v-col cols="12" lg="6" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-text-field
								:action-name="actions.CREATE"
								context="account"
								:label="$t('contact-info.mobile-number')"
								v-model="contact_info.mobile_number"
								:rules="[rules.phone]"
							></bee-text-field>
						</v-col>

						<v-col cols="12" lg="6" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-text-field
								:action-name="actions.CREATE"
								context="account"
								:label="$t('contact-info.phone-number')"
								:rules="[rules.phone]"
								v-model="contact_info.phone_number "
							></bee-text-field>
						</v-col>

						<v-col cols="12" lg="6" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-text-field
								:action-name="actions.CREATE"
								context="account"
								:label="$t('contact-info.email')"
								:rules="[rules.email]"
								v-model="contact_info.email"
							></bee-text-field>
						</v-col>

						<v-col cols="12" lg="6" md="6" sm="6" xs="12" class="px-lg-1 pt-lg-0 pb-lg-1">
							<bee-text-field
								:action-name="actions.CREATE"
								context="account"
								:label="$t('contact-info.address')"
								v-model="contact_info.address"
							></bee-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="pb-4 pt-0">
					<bee-btn
						context="account"
						:action-name="actions.CREATE"
						:content="$t('save')"
						icon="fa-user-check"
						color="primary"
						@click="save()"
						:loading="loading"
						:disabled="!valid"
						outer-class="mx-3"
					></bee-btn>
					<bee-btn
						context="account"
						:action-name="actions.CREATE"
						:content="$t('cancel')"
						color="deletingColor"
						:loading="loading"
						@click="reset()"
					></bee-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>
<script>
import { mapState } from "vuex";
import rules from "../../../../validation";
import store from "../../../../store/index.js";
import actions from "../../../../permissions/actions-names.js";
export default {
	props: ["value"],
	data: () => ({
		actions,
		valid: false,
		account: {
			custom_statement_ids: null,
			name: null,
			inner_accounting_no: null,
			is_box: null,
			type: null,
			final_type: null,
			max_credit_amount: null,
			max_debit_amount: null,
			is_debt_forbidden: false,
			notes: null,
			parent_account_id: null,
			id: null,
			contact_info: null
		},
		...rules,
		loading: false,
		contact_info: {
			id: null,
			mobile_number: null,
			phone_number: null,
			address: null,
			email: null
		},
		default_account: {
			accounting_no: null,
			name: null,
			inner_accounting_no: null,
			is_box: null,
			type: null,
			final_type: null,
			max_credit_amount: {
				amount: null,
				currency_id: null
			},
			max_debit_amount: {
				amount: null,
				currency_id: null
			},
			is_debt_forbidden: null,
			notes: null,
			contact_info_id: null,
			parent_account_id: null,
			id: null,
			contact_info: {
				id: null,
				mobile_number: null,
				phone_number: null,
				address: null,
				email: null,
				account_id: null
			}
		}
	}),
	computed: {
		...mapState("configs", ["configs"]),
		...mapState("customStatements", ["custom_statements"]),
		prefix() {
			if (this.account.parent_account_id)
				return this.configs.accounts
					.find(c => c.id == this.account.parent_account_id)
					.accounting_no.toString();
			return null;
		},
		localValue: {
			get: function() {
				return this.value;
			},
			set: function(value) {
				this.$emit("input", value);
			}
		}
	},
	methods: {
		save() {
			this.loading = true;
            this.account.contact_info = { ...this.contact_info };
            
			if (this.account.max_credit_amount?.amount){
                this.account.max_credit_amount.currency_id = this.configs.financial_file.default_currency_id;
            }
            else {
                this.account.max_credit_amount = null
            }
            
			if (this.account.max_debit_amount?.amount){
                this.account.max_debit_amount.currency_id = this.configs.financial_file.default_currency_id;
            }
            else {
                this.account.max_debit_amount = null
            }
            
			store.dispatch("accounts/create", this.account)
            .then(() => {
                Promise.all([
                    store.dispatch("configs/fetchAll"),
                    store.dispatch("customStatements/fetchAll")
                ]);
                this.reset();
            })
            .finally(() => {
                this.loading = false;
            });
		},
		reset() {
			this.account = { ...this.default_account };
			this.localValue = false;
		},
		change() {
			this.$nextTick(() => {
				this.$refs.accountNum.setFocus();
				if (this.account.parent_account_id){
					store.dispatch(
                        "accounts/GenerateNewAccountNo",
                        this.account.parent_account_id
                    )
                    .then(response => {
                        this.account.inner_accounting_no = response;
                    });
                }
			});
		},
		onTypeChanged() {
			if (this.account.type == 1) this.account.custom_statement_ids = null;
		}
	},

	i18n: {
		messages: {
			ar: {
				'create-account': 'إنشاء حساب',
				'account-name': 'اسم الحساب',
				'main-account': 'الحساب الأساسي',


				
				'account-type': {
					label: 'نوع الحساب',
					main: 'أساسي',
					sub: 'فرعي',
					operations: 'تشغيل',
					trade: 'مُتاجرة',
					'gains-and-losses': 'أرباح وخسائر',
					budget: 'ميزانية',
				},

				'final-account': 'الحساب الختامي',
				
				account: {
					'custom-statement': 'كشف مُخصص',
					'max-debit-amount': 'سقف المدين',
					'max-credit-amount': 'سقف المدين',
					'debt-is-forbidden': 'ممنوع من الدين',
					notes: 'ملاحظات',
				},

				'contact-info':{
					'mobile-number': 'رقم الجوال',
					'phone-number': 'رقم الهاتف',
					email: 'البريد الإلكتروني',
					address: 'العنوان',
				},

				save: 'حفظ',
				cancel: 'إلغاء',
			},
			en: {
				'create-account': 'Create account',
				'account-name': 'Account name',
				'main-account': 'Main account',

				'account-type': {
					label: 'Account type',
					main: 'Main account',
					sub: 'Sub account',
					operations: 'Operating',
					trade: 'Trading',
					'gains-and-losses': 'Profit and losses',
					budget: 'Balance sheet',
				},

				'final-account': 'Final account',
				
				account: {
					'custom-statement': 'Customised statement',
					'max-debit-amount': 'Debit limit',
					'max-credit-amount': 'Credit limit',
					'debt-is-forbidden': 'Banned from debt',
					notes: 'Notes',
				},

				'contact-info':{
					'mobile-number': 'Mobile number',
					'phone-number': 'Phone number',
					email: 'Email',
					address: 'Address',
				},

				save: 'Save',
				cancel: 'Cancel',
			},
			es: {
				'create-account': 'Crear una cuenta',
				'account-name': 'Nombre de la cuenta',
				'main-account': 'Cuenta principal',

				'account-type': {
					label: 'Tipo de cuenta',
					main: 'Principal',
					sub: 'Sub',
					operations: 'Operaciones',
					trade: 'Comercio',
					'gains-and-losses': 'Ganancias y pérdidas',
					budget: 'Presupuesto',
				},

				'final-account': 'Cuenta final',
				
				account: {
					'custom-statement': 'Declaración personalizada',
					'max-debit-amount': 'Cantidad máxima de débito',
					'max-credit-amount': 'Monto máximo de crédito',
					'debt-is-forbidden': 'la deuda esta prohibida',
					notes: 'Notes',
				},

				'contact-info':{
					'mobile-number': 'Número de teléfono móvil',
					'phone-number': 'Número de teléfono',
					email: 'Correo electrónico',
					address: 'Dirección',
				},

				save: 'Ahorrar',
				cancel: 'Cancelar',
			},
		}
	}
};
</script>
<style scoped>
</style>
